import { SET_LOADER_VISIBILITY } from "../actions/action-types.js";

export default function loader(state = true, {type, payload}) {
    switch (type) {
        case SET_LOADER_VISIBILITY:
            return (state = payload)
        default:
            return state
    }
}